<template>
  <div>
    <v-container grid-list-md class="white text-left">
      <v-row>
        <v-col cols="12" class="body-2 grey--text text-left pb-0">
          <div>
            <v-breadcrumbs :items="routeItems" divider=">"></v-breadcrumbs>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="headline pb-0"
          >No. Transferencia: {{ dataTransfer.id }}</v-col
        >
        <v-col cols="12" class="pt-1 pb-0 text-subtitle-1">
          From:<span class="grey--text ml-2">{{
            dataTransfer.location_from
          }}</span></v-col
        >
        <v-col cols="12" class="pt-0 text-subtitle-1">
          To:
          <span class="grey--text ml-2">{{ dataTransfer.location_to }}</span>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="!exist">
      <v-row no-gutters>
        <v-col cols="12" class="text-center"
          >La transferencia que buscaste no pudo ser encontrada.</v-col
        >
      </v-row>
    </v-container>
    <v-container v-show="exist" class="pt-0">
      <v-col cols="12" class="pb-0">
        <v-card class="pa-2">
          <p class="title ml-1 mt-2 mb-0 font-weight-regular">
            Equipo: {{ dataTransfer.productName }}
          </p>
        </v-card>
      </v-col>
      <v-col cols="12" class="pt-0">
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header class="pa-2 py-0">
              <span class="red--text font-weight-light">
                {{ statusCheckOnly }}
              </span>
              <template v-slot:actions>
                <v-icon>add</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="background-gray">
              <v-container class="pa-0">
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      block
                      :color="checkStatusOutput ? 'gray' : 'red'"
                      :dark="!checkStatusOutput ? true : false"
                      class="d-flex justify-space-between"
                      @click="
                        checkStatusOutput
                          ? checklistDetail('output', dataTransfer.key)
                          : createChecklist('output')
                      "
                    >
                      <span class="text-uppercase">Salida</span>
                      <span
                        class="text-capitalize caption"
                        v-if="!checkStatusOutput"
                        >realizar checklist</span
                      >
                      <span class="text-capitalize caption" v-else
                        >Checklist Realizado</span
                      >
                    </v-btn>
                  </v-col>
                  <v-col cols="12 pt-0">
                    <v-btn
                      block
                      :disabled="disableInput"
                      :color="checkStatusInput ? 'gray' : 'red'"
                      :dark="
                        !checkStatusInput && checkStatusOutput ? true : false
                      "
                      class="d-flex justify-space-between"
                      @click="
                        checkStatusInput
                          ? checklistDetail('input', dataTransfer.key)
                          : createChecklist('input')
                      "
                    >
                      <span class="text-uppercase">Entrada</span>
                      <span
                        class="text-capitalize caption"
                        v-if="!checkStatusInput && checkStatusOutput"
                        >realizar checklist</span
                      >
                      <span
                        class="text-capitalize caption"
                        v-if="checkStatusInput && checkStatusOutput"
                        >Checklist Realizado</span
                      >
                      <span
                        class="text-capitalize caption"
                        v-if="!checkStatusOutput"
                        >por realizar</span
                      >
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  data() {
    return {
      exist: true,
      dataTransfer: {}
    };
  },
  async mounted() {
    if (this.$route.params.id) {
      const data = await this.getDetail(this.$route.params.id);
      if (data) {
        this.dataTransfer = data;
      } else {
        this.exist = false;
      }
    } else {
      this.exist = false;
    }
  },
  computed: {
    ...mapState("detail", ["dataEquipment"]),
    disableInput() {
      if (this.dataTransfer) {
        if (this.dataTransfer.statusMap) {
          if (this.dataTransfer.statusMap.input) {
            return false;
          }
          return true;
        }
        return true;
      }
      return true;
    },
    statusCheckOnly() {
      if (this.dataTransfer) {
        if (this.dataTransfer.statusMap) {
          if (
            this.dataTransfer.statusMap.input &&
            !this.dataTransfer.statusMap.output
          ) {
            return "Realizar Checklist - Entrega";
          }
          if (this.dataTransfer.statusMap.output) {
            return "Checklist Realizados";
          }
          return "Realizar Checklist - Salida";
        }
        return "Realizar Checklist - Salida";
      }
      return "";
    },
    checkStatusOutput() {
      if (this.dataTransfer) {
        if (this.dataTransfer.statusMap) {
          if (this.dataTransfer.statusMap.input) {
            return true;
          }
          return false;
        }
        return false;
      }
      return false;
    },
    checkStatusInput() {
      if (this.dataTransfer) {
        if (this.dataTransfer.statusMap) {
          if (this.dataTransfer.statusMap.output) {
            return true;
          }
          return false;
        }
        return false;
      }
      return false;
    },
    routeItems() {
      let routeItems = [];
      let path = "";
      this.$router.currentRoute.fullPath.split("/").forEach(element => {
        path += element + "/";
        routeItems.push({
          text:
            element.length > 0
              ? element.charAt(0).toUpperCase() + element.substring(1)
              : "Inicio",
          disabled: false,
          href: path
        });
        if (routeItems[routeItems.length - 1].text === "Inicio")
          routeItems.splice(-1, 1);
      });
      return routeItems;
    }
  },
  methods: {
    ...mapActions("transfers", ["getDetail"]),
    createChecklist(event) {
      this.$router.push({
        name: "transfer-checklist",
        params: {
          id: this.dataTransfer.key,
          event: event,
          action: "guardar"
        }
      });
    },
    checklistDetail(event) {
      this.$router.push({
        name: "transfer-checklist",
        params: {
          id: this.dataTransfer.key,
          event: event,
          action: "detalle"
        }
      });
    }
  }
};
</script>

<style scoped>
.background-gray {
  background-color: #efefef;
}
.v-expansion-panel__header {
  padding: 0 0 0 5px !important;
}
.v-expansion-panel--active
  > .v-expansion-panel-header--active
  .v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate)
  .v-icon {
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
}
</style>
